import {
  Box,
  Button,
  // CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import ButtonCta1 from "../button/ButtonCta1";
import { styled } from "@mui/system";
import CustomAutocomplete from "../autocomplete/Autocomplete";
import { CustomTextField, isValidFileType } from "../../helpers/helper";
import { ReactComponent as ButtonChart } from "../../assets/images/ButtonChart.svg";
import {
  BASE_URL,
  OCP_APIM_SUBSCRIPTION_KEY,
  subjectLineOptions,
  toastConfig,
} from "../../constants/constant";
import CommonDialog from "./CommonDialog";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ResponsiveLoader from "../loader/ResponsiveLoader";

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "&.MuiDialog-paper": {
    borderRadius: 12,
  },
}));

const FeedbackDialog = ({
  open,
  setOpen,
  title,
  leftButtonText,
  rightButtonText,
}) => {
  const fileInputRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [isNotValidFile, setIsNotValidFile] = useState(false);
  const [isNotValidFileSize, setIsNotValidFileSize] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [description, setDescription] = useState("");
  const [customField, setCustomField] = useState({
    id: "",
    fieldName: "",
  });
  const [isNotValidDescription, setIsNotValidDescription] = useState(false);
  const userEmailId = useSelector((state) => state?.user?.emailId);

  const areInputsFilled = () => {
    return description?.trim() !== "" && customField?.fieldName !== "";
  };
  const inputFilled = areInputsFilled();

  // const handleClose = () => {
  //   setOpen(false);
  // };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  const handleCancel = () => {
    if (files?.length || description || customField?.fieldName) {
      setConfirmOpen(true);
    } else {
      setOpen(false);
    }
  };

  const handleConfirmCancel = () => {
    setOpen(false);
    setConfirmOpen(false);
    setFiles([]);
    setDescription("");
    setCustomField({
      id: "",
      fieldName: "",
    });
  };

  const handleSubmit = () => {
    createFeedbackForm();
  };

  const getOrgLabelCustom = (option) => option?.fieldName;

  const handleAutoCompleteChangeCustom = (name, value) => {
    setCustomField({ ...value });
  };

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    const isValid = isValidFileType(newFiles[0]);
    const fileSize = newFiles[0]?.size;
    const sizeInMB = (fileSize / (1024 * 1024)).toFixed(0);
    console.log("newFiles>>>>>", newFiles, sizeInMB);
    if (isValid && sizeInMB < 25) {
      setFiles([...files, ...newFiles]);
      setIsNotValidFile(false);
      setIsNotValidFileSize(false);
    }
    if (!isValid) {
      setIsNotValidFile(true);
      setIsNotValidFileSize(false);
    }
    if (sizeInMB > 25) {
      setIsNotValidFileSize(true);
      setIsNotValidFile(false);
    }
  };

  const handleDelete = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    if(!value.match(/^.*[a-zA-Z0-9]+.*$/) && value.length == 500)
      setIsNotValidDescription(true);
    else
      setIsNotValidDescription(false);
    setDescription(value);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const createFeedbackForm = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("UserEmail", userEmailId);
    formData.append("Type", customField?.fieldName);
    formData.append("Description", description);
    // formData.append("Attachment", files);
    for (let i = 0; i < files.length; i++) {
      formData.append("Attachments", files[i]);
    }
    console.log("formData>>>", formData);
    let url = `${BASE_URL}/api/Misc/AddFeedbackForm`;
    const user_token = localStorage.getItem("bb_access_token");
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY,
        Authorization: "Bearer  " + user_token,
      },
    };
    try {
      let data = await axios.post(url, formData, config);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        handleConfirmCancel();
        toast.success("Feedback has been submitted successfully", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  return (
    <>
      <CustomDialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {loader && (
          <ResponsiveLoader
            loading={loader}
            message="Your file(s) is being uploaded. It may take a few moments, thank you for your understanding!"
          />
        )}
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            color: "#a50218",
            fontFamily: "Montserrat",
            padding: "32px 32px 12px 32px",
            fontWeight: 700,
            fontSize: "1.75rem",
          }}
        >
          {title || ""}
        </DialogTitle>
        <DialogContent
          sx={{ minWidth: "600px", minHeight: "370px", padding: "20px 32px" }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
              }}
            >
              <label style={labelStyle}>
                Subject Line<sup style={requiredAr}>*</sup>
              </label>
              <CustomAutocomplete
                options={subjectLineOptions}
                value={customField}
                disabled={false}
                onChange={(e, value) => {
                  if (value === null) {
                    value = {
                      id: "",
                      fieldName: "",
                    };
                  }
                  handleAutoCompleteChangeCustom("customField", value);
                }}
                getOptionLabel={getOrgLabelCustom}
                placeholder="Select a subject line..."
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
              }}
            >
              <label style={labelStyle}>
                Description<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter description here..."
                multiline
                rows={4}
                maxRows={8}
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="description"
                value={description}
                onChange={handleChange}
                inputProps={{
                  MAXLENGTH: 500,
                }}
              />
                 <Typography
                sx={{
                  fontSize: "12px",
                  letterSpacing: "-0.02em",
                  lineHeight: "16px",
                  fontWeight: 600,
                  fontFamily: "Montserrat",
                  color: "#a50218",
                  textAlign: "left",
                  paddingTop: "8px",
                }}
              >
                {isNotValidDescription && (
                  <div>"The description cannot have all special characters"</div>
                )}
              </Typography>
            </Box>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
              }}
            >
              <label style={labelStyle}>Upload Files</label>
              <input
                type="file"
                accept="image/*,video/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                multiple
                onChange={handleFileChange}
              />
              <Button
                sx={uploadButtonStyle}
                variant="outlined"
                startIcon={<ButtonChart />}
                onClick={() => handleButtonClick("upload")}
              >
                Choose File
              </Button>
              <Typography
                sx={{
                  fontSize: "12px",
                  letterSpacing: "-0.02em",
                  lineHeight: "16px",
                  fontWeight: isNotValidFile || isNotValidFileSize ? 600 : 500,
                  fontFamily: "Montserrat",
                  color:
                    isNotValidFile || isNotValidFileSize
                      ? "#a50218"
                      : "#8a8a8a",
                  textAlign: "left",
                  paddingTop: "8px",
                }}
              >
                {!isNotValidFile && !isNotValidFileSize && (
                  <div>
                    "Supported: .png, .jpg, .jpeg, .mp4 and the file size should
                    be less than 25Mb."
                  </div>
                )}
                {isNotValidFileSize && (
                  <div>"The file size should be less than 25Mb."</div>
                )}
                {isNotValidFile && (
                  <div>
                    "Unsupported File Type! Please upload the file in .png,
                    .jpg, .jpeg, .mp4 format only."
                  </div>
                )}
              </Typography>
              {files?.length > 0 && (
                <div style={{ marginTop: 10, position: "relative" }}>
                  {files?.map((file, index) => (
                    <div
                      key={index}
                      style={{ marginBottom: 10, position: "relative" }}
                    >
                      {file.type.startsWith("image") ? (
                        <img
                          src={URL.createObjectURL(file)}
                          alt={`File ${index}`}
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                      ) : (
                        <video controls width="100%" height="240">
                          <source
                            src={URL.createObjectURL(file)}
                            type={file.type}
                          />
                          Your browser does not support the video tag.
                        </video>
                      )}
                      <Button
                        onClick={() => handleDelete(index)}
                        sx={deleteButtonStyle}
                      >
                        X
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Box>
        </DialogContent>
        <Divider sx={{ height: "0.5px", marginBottom: "20px" }} />
        <DialogActions sx={{ padding: "0 32px 20px 32px" }}>
          <Box>
            <ButtonCta1
              text={leftButtonText}
              variant="contained"
              onClick={handleCancel}
              bgColor="#e0e0e0"
              color="#5a5a5a"
            />
          </Box>
          <Box style={{ marginLeft: "20px" }}>
            <ButtonCta1
              text={rightButtonText}
              disabled={!inputFilled}
              variant="contained"
              onClick={handleSubmit}
              autoFocus
              bgColor="#a50218"
              color="#fff"
            />
          </Box>
        </DialogActions>
      </CustomDialog>

      <CommonDialog
        open={confirmOpen}
        setOpen={setConfirmOpen}
        handleCancel={handleConfirmClose}
        handleDone={handleConfirmCancel}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default FeedbackDialog;

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const uploadButtonStyle = {
  width: "30%",
  height: "48px",
  textTransform: "capitalize",
  border: `1px solid #f7954c`,
  backgroundColor: "#fff",
  fontSize: "16px",
  fontWeight: 600,
  letterSpacing: "-0.02em",
  fontFamily: "Montserrat",
  color: "#f7954c",
  textAlign: "center",
  "&:hover": {
    background: "transparent",
    border: `1px solid #f7954c`,
  },
};

const deleteButtonStyle = {
  position: "absolute",
  top: 0,
  right: 0,
  padding: "4px 8px",
  backgroundColor: "red",
  color: "white",
  border: "none",
  borderRadius: "4px",
  fontFamily: "Montserrat",
  cursor: "pointer",
  height: "25px",
  minWidth: "25px",
  "&:hover": {
    backgroundColor: "rgba(255, 0, 0, 0.75)",
  },
};

// <Box
//   sx={{
//     height: "370px",
//     width: "100%",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   }}
// >
//   <CircularProgress />
// </Box>
